import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ErrorHandlerService } from './pipe.service';
import { environment } from 'src/enviroment/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService) {}

  loginWithExisting(loginDetails: any): Observable<any> {
    return this.http.post<any>(environment.serverUrl + '/api/candidate/signin', loginDetails).pipe(
      this.errorHandler.handleError()
    );
  }
  
  validateEmailForSignUp(email: string): Observable<any> {
    return this.http.get<any>(environment.serverUrl + '/api/candidate/exists?loginDto=' + email).pipe(
      this.errorHandler.handleError()
    );
  }

  validateEmailForVerification(email: string): Observable<any> {
    return this.http.get<any>(environment.serverUrl + '/api/candidate/isValidated?loginDto=' + email).pipe(
      this.errorHandler.handleError()
    );
  }

  validateUser(userDetails: any): Observable<any> {
    return this.http.post<any>(environment.serverUrl + '/api/candidate/validate', userDetails).pipe(
      this.errorHandler.handleError()
    )
  }

  getPackages(): Observable<any> {
    return this.http.get<any>(environment.serverUrl + '/api/packages').pipe(
      this.errorHandler.handleError()
    );
  }

  signUpAsNewUser(userDetails: any): Observable<any> {
    return this.http.post<any>(environment.serverUrl + '/api/candidate/signup', userDetails).pipe(
      this.errorHandler.handleError()
    )
  }

  registerNew(registerDetails: any): Observable<any> {
    return this.http.post<any>(environment.serverUrl + '/api/candidate/register', registerDetails).pipe(
      this.errorHandler.handleError()
    )
  }
}